import React from 'react';

import Model from './model';
import TestModel from './testmodel';
import OntologyHelper from './ontology_helper';

import Asset from './viewselect';
import Show from './show';
import Spinner from './spinner';
import i18n from 'i18next';

/** Компонент приложения */
class ViewsAsset extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {}
		this.model = new Model(this.props.rpc_url) 
		this.model.setLoadListener(this);
		this.goAsset = this.goAsset.bind(this);
		this.goHome = this.goHome.bind(this);
		this.goView = this.goView.bind(this);
		this.goShow = this.goShow.bind(this);
		
	}

	componentDidMount(){
		const {asset, showView} = this.props;
		this.model.getOntology()
			.then(response => {
				this.setState({ ontology: new OntologyHelper(response), asset, view: undefined, show: undefined});
				if (showView && showView.id)
					this.model.getView(showView.id)
						.then(response => {
							this.setState({show: response.view});
						})	
			})
	}
	goHome(e){
		if(e) e.preventDefault()
		this.setState({view: undefined, show: undefined})
	}
	goAsset(e, asset){
		e.preventDefault()
		this.setState({asset: asset, view: undefined, show: undefined})
	}
	goView(e, view){
		e.preventDefault()
		//console.log('goView', view);
		this.setState({view: view, show: undefined})
	}
	goShow(e, view){
		e.preventDefault()
		//console.log('goShow', view)
		const view_title = view.view_title
		if (this.props.enabled && Array.isArray(this.props.enabled) && this.props.enabled.length>0){
			if (!(this.props.enabled.includes(view.type) || this.props.enabled.includes(view.id) || this.props.enabled.includes(view.view_title))){
				alert(i18n.t('views.model.no_used', {view_title}));
				return;	
			}
		}
		this.model.getView(view.id)
			.then(response => {
				this.setState({show: response.view});
			})
		//this.setState({show: view})
	}

	loadStart(){
		//console.log('fireLoadStart')
		this.setState({loading: true})
		//console.log(JSON.stringify(this.state))
	}
	loadDone(){
		//console.log('fireLoadDone')
		this.setState({loading: false})
		//console.log(JSON.stringify(this.state))

	}
	loadError(error){
		//console.log('fireLoadError', error)	
		alert("Произошла ошибка\n" + error.message + "\n" + error.debug);
		this.setState({loading: false})
	}

	showURL(e){
		if (this.state.show){
			const {asset_id, id} = this.state.show;
			const url =  window.location.protocol+'//'+window.location.host+window.location.pathname+"#/adms/"+encodeURIComponent(asset_id)+"?view="+id;
			navigator.clipboard.writeText(url);
			alert(i18n.t('views.model.copied_link', {url}));
		}
	}
	
	render(){
		//console.log(this);
		const isLoading = this.state.loading// || true
		//console.log('render loading', isLoading)
		return (
			<div className="setup-view-app">
				{this.renderContent()}
				{isLoading && (<div className="loading-overlay"></div>)}
				
			</div>
		)
	}
	
	renderContent(){
		if(this.state.show)
			return (
				<div>
				<div className="add-buttons" style={{display: "flex"}}>
				  <div style={{textAlign: "left", width: "60%", float:"left"}}>&nbsp;{this.state.show.view_description && <h3>{this.state.show.view_description}</h3>}</div>
					<div style={{width: "40%", float:"left"}}>
						 <button type="button" className="btn btn-light" onClick={(e) => this.goHome(e)}>{i18n.t('views.model.back')}</button>&nbsp;
						 <button type="button" className="btn btn-light" onClick={(e) => this.showURL(e)}>{i18n.t('views.model.copy_link')}</button>
					</div>
				</div>
				<Show
					model = {this.model}
					view = {this.state.show} 
					goHome = {this.goHome}
				/>
				</div>
			);
		if(this.state.asset)
			return (
				<Asset 
					model = {this.model}
					ontology = {this.state.ontology}
					asset = {this.state.asset} 
					goView = {this.goShow}
				/>
			);
		if(this.state.ontology)
			return (
				<Spinner text={i18n.t('view.loading')}/>
			);

		return (<Spinner text={i18n.t('app.loading')}/>)
	}

}

export default ViewsAsset;